module.exports = __webpack_public_path__ + "img/logo-a3.353c05e8.png";